import React from 'react';

import CreateAccountScreenSucess from '@giro-auth/screens/CreateAccountSucess/CreateAccountSucess.screen';

const CreateAccountSucessContainer = () => {
  return <CreateAccountScreenSucess />;
};

export default CreateAccountSucessContainer;
